module.exports = __webpack_public_path__ + "static/logo.c6a1cb37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/logo.svg
// module id = 49
// module chunks = 35783957827783 70144966829960 114276838955818